export const NULL_GROUP_ID = 'null';
export const EMPTY_FIELD = '--';
export const MINIMUM_SEARCH_TERM_LENGTH = 2;

export const CURRENCY_OPTIONS = [
  'USD',
  'EUR',
  'GBP',
  'CAD',
  'MXN',
  'AUD',
  'CHF',
  'JPY',
  'CNY',
  'INR',
  'BRL',
  'ARS',
  'CLP',
  'COP',
] as const;

// Countries we currently support adding accounts for.
export const SUPPORTED_COUNTRY_CODES = new Set([
  'US', // United States
  'CA', // Canada
  'MX', // Mexico
  'GB', // Great Britain
  'JP', // Japan
  'IN', // India
  'ID', // Indonesia
]);
